import { MainLayout } from 'shared/ui/layout/main';

export function ReportLayout() {
  return <MainLayout />;
}
